<template>
  <el-form :model="templateForm" :rules="rules" ref="templateForm" label-width="160px" class="demo-templateForm">
    <el-form-item :label="generateCustomizeString('templateName')" prop="name">
      <el-input v-model="templateForm.name"></el-input>
    </el-form-item>
    <!-- 一克多少钱 -->
    <el-form-item :label="generateCustomizeString('feePerQuantity')" prop="fee_per_quantity">
      <el-input size="mini" v-model="templateForm.fee_per_quantity" type="number" min="0" @change="setTwoNumberDecimal()">
        <template slot="prepend">NZD $</template>
      </el-input>
    </el-form-item>
    <el-form-item  :label="generateCustomizeString('minPackageWeight')" prop="min_package_weight">
      <el-input size="mini" v-model="templateForm.min_package_weight" type="number" min="1" @change="setTwoNumberDecimal()"></el-input>
    </el-form-item>
    <!-- 分包规则 -->
    <el-card class="box-card" style="max-width: 1280px;">
      <el-popover
        ref="popover1"
        placement="top-start"
        :title="generateCustomizeString('parcelSplitRule')"
        width="200"
        trigger="hover">
        <p>{{ generateCustomizeString('courierMsg1') }}</p>
        <p>{{ generateCustomizeString('courierMsg2') }}</p>
      </el-popover>
      <el-button v-popover:popover1>{{ generateCustomizeString('parcelSplitRule') }}</el-button>
      <el-table
        ref="ruleTable"
        :data="templateForm.rules"
        highlight-current-row
        style="width: 80%">
        <el-table-column
          type="index">
        </el-table-column>
        <el-table-column
          property="express_type"
          :label="generateCustomizeString('expressType')">
          <template slot-scope="scope">
            <el-select v-model="scope.row.express_type" placeholder="select" @change="onChange">
              <el-option
                v-for="(option, index) in expressTypeOptions"
                :key="index"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          property="package_type"
          :label="generateCustomizeString('packageType')"
          width="120">
          <template slot-scope="scope">
          <el-select v-model="scope.row.package_type" placeholder="select" @change="onChange">
            <el-option
              v-for="(option, index) in packageTypeOptions"
              :key="index"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
          </template>
        </el-table-column>
        <el-table-column
          property="typeName"
          :label="generateCustomizeString('packageRuleType')"
        >
        </el-table-column>
        <el-table-column
          property="value"
          :label="generateCustomizeString('value')">
          <template slot-scope="scope" >
            <el-input
              placeholder="Please input"
              size="mini"
              v-model="scope.row.value"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="100">
          <template slot-scope="scope">
            <el-button @click="onDelete(scope.$index)" type="text" size="small">{{generateCustomizeString('delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button @click="addRuleCell()">{{generateCustomizeString('addRule')}}</el-button>
      </div>
    </el-card>
    <el-form-item style="margin-top: 40px;">
      <el-button type="primary" style="width: 100px;" @click="onSubmit">{{generateCustomizeString('save')}}</el-button>
      <el-button style="margin-left: 30px; width: 100px;" @click="onCancel">{{generateCustomizeString('cancel')}}</el-button>
    </el-form-item>
    <div>
      <el-col :span="12" style="padding: 10px 20px 30px 10px;">
        <div style="font-size: 14px; color: #808080;">
          <h3>{{ generateCustomizeString('shippingFeeCalcutation') }}</h3>
          <p><b>{{ generateCustomizeString('shippingFeeMsg1') }}</b></p>
          <p>{{ generateCustomizeString('shippingFeeMsg2') }}</p>
          <p>{{ generateCustomizeString('shippingFeeMsg3') }}</p>
          <p><b>{{ generateCustomizeString('shippingFeeMsg4') }}</b></p>
          <p>{{ generateCustomizeString('shippingFeeMsg5') }}</p>
          <p><b>{{ generateCustomizeString('shippingFeeMsg6') }}</b></p>
          <p>{{ generateCustomizeString('shippingFeeMsg7') }}</p>
          <p><b>{{ generateCustomizeString('shippingFeeMsg8') }}</b></p>
        </div>
      </el-col>
      <el-col :span="12" style="padding: 10px 0 30px 20px;">
        <div style="font-size: 14px; color: #808080;">
          <h3>{{ generateCustomizeString('shippingTemplateMsg1') }}</h3>
          <p><b>{{ generateCustomizeString('parcelRestriction') }}</b></p>
          <p>{{ generateCustomizeString('shippingTemplateMsg2') }}</p>
          <p>&nbsp;&nbsp;{{ generateCustomizeString('cosmetics') }}<span style="padding-left: 50px;">{{ generateCustomizeString('single') }}</span><span style="padding-left: 110px;">6</span></p>
          <p>&nbsp;&nbsp;{{ generateCustomizeString('cosmetics') }}<span style="padding-left: 50px;">{{ generateCustomizeString('mix') }}</span><span style="padding-left: 110px;">4</span></p>
          <p>&nbsp;&nbsp;{{ generateCustomizeString('skinCareProduct') }}<span style="padding-left: 35px;">{{ generateCustomizeString('unrestricted') }}</span><span style="padding-left: 97px;">2</span></p>
          <p><b>{{ generateCustomizeString('minParcelWeight') }}</b></p>
          <p>&nbsp;&nbsp;1000g</p>
          <p><b>{{ generateCustomizeString('shippingTemplateMsg3') }}</b> {{ generateCustomizeString('shippingTemplateMsg4') }}</p>
          <p><b>{{ generateCustomizeString('shippingTemplateMsg5') }}</b> {{ generateCustomizeString('shippingTemplateMsg6') }}</p>
        </div>
      </el-col>
    </div>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultRule = {
  express_type: 1,
  value: 1,
  package_type: 1,
  type: 0,
  typeName: '每包裹最大件数'
}

const defaultTepmlate = {
  name: '',
  min_package_weight: 1,
  fee_per_quantity: 1,
  rules: [],
  type: 0
}

export default {
  name: 'ExpressTemplateDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templateForm: Object.assign({}, defaultTepmlate),
      tplRules: [],
      packageTypeOptions: [
        { label: '单/混包', value: 0 },
        { label: '单包', value: 1 },
        { label: '混包', value: 2 }
      ],
      expressTypeOptions: [],
      rules: {
        name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        fee_per_quantity: [
          {
            required: true,
            // pattern: '^[0-9]+(.[0-9]{1,2})?$',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        min_package_weight: [
          {
            required: true,
            // pattern: '^[0-9]+(.[0-9]{1,2})?$',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    addRuleCell() {
      this.templateForm.rules.push(Object.assign({}, defaultRule))
    },
    setTwoNumberDecimal(event) {
      this.templateForm.min_package_weight = parseFloat(this.templateForm.min_package_weight).toFixed(2)
      this.templateForm.fee_per_quantity = parseFloat(this.templateForm.fee_per_quantity).toFixed(2)
    },
    onSubmit() {
      if (this.isEdit) {
        this.updateTemplate()
      } else {
        this.createTemplate()
      }
    },
    onCancel() {
      this.$router.push({ name: 'Template' })
    },
    onChange() {
      console.log(this.tplRules)
    },
    onDelete(index) {
      this.templateForm.rules.splice(index, 1)
    },
    fetchTemplate() {
      return new Promise((resolve, reject) => {
        request({
          url: `express/template/${this.$route.params.templateId}`,
          method: 'get'
        })
          .then(res => {
            const data = res.data
            data.fee_per_quantity = (data.fee_per_quantity / 100).toFixed(2)
            data.rules = data.rules.map(rule => {
              rule.typeName = rule.type === 0 ? '每包裹最大件数' : 'unknow'
              return rule
            })
            this.templateForm = res.data
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
          .finally(() => {
            this.fetchLoding = false
          })
      })
    },
    createTemplate() {
      this.$refs.templateForm.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.templateForm)
          data.fee_per_quantity = Math.round(data.fee_per_quantity * 100)
          request({
            url: 'express/template',
            method: 'post',
            data
          })
            .then(res => {
              if (res.status === 0) {
                this.$message({
                  message: this.generateCustomizeString('createdSuccessfully'),
                  type: 'success'
                })
                this.$store.dispatch('delCurrentViews', {
                  view: this.$route,
                  $router: this.$router
                })
                this.$router.replace({ name: 'Template' })
              } else {
                this.$message.error(this.generateCustomizeString('createFailed'))
              }
            })
            .catch(error => {
              console.log(error)
              this.$message.error(this.generateCustomizeString('createFailed'))
            })
        } else {
          console.warn('validate error')
          return false
        }
      })
    },
    updateTemplate() {
      this.$refs.templateForm.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.templateForm)
          data.fee_per_quantity = Math.round(data.fee_per_quantity * 100)
          request({
            url: `express/template/${this.$route.params.templateId}`,
            method: 'put',
            data
          })
            .then(res => {
              if (res.status === 0) {
                this.$message({
                  message: this.generateCustomizeString('updateSuccessfully'),
                  type: 'success'
                })
                this.$router.replace({ name: 'Template' })
              } else {
                this.$message.error(this.generateCustomizeString('updateFailed'))
              }
            })
            .catch(error => {
              console.log(error)
              this.$message.error(this.generateCustomizeString('updateFailed'))
            })
        } else {
          console.warn('validate error')
          return false
        }
      })
    },
    fetchExpressType() {
      request({
        url: 'express/type/list',
        method: 'get'
      })
        .then(response => {
          const data = response.data.map(type => {
            type.label = type.name
            type.value = type.type
            return type
          })
          this.expressTypeOptions = data
        })
    }
  },
  created() {
    this.fetchExpressType()
    if (this.isEdit || this.isView) {
      this.fetchTemplate()
    } else {
      this.templateForm = Object.assign({}, defaultTepmlate)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rowClass {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.demo-templateForm {
  padding: 50px 50px 0px 50px;
}
.fee {
  font-size: 16px important;
  font-weight: bold;
}
</style>
